import React from "react"

import { Heading, Flex, Box } from "@singita/components"
import { FORM_STATUS } from "../common/constants"
import { Translation } from "react-i18next"

export const FormConfirmation = ({
  response,
  message,
  uploadError,
  children,
}) => {
  return (
    <Flex>
      <Box>
        {response === FORM_STATUS.SUCCESS && !uploadError ? (
          <>
            <Heading size="h3">{message}</Heading>
            <Flex mt={[4]}>{children}</Flex>
          </>
        ) : null}

        {response === FORM_STATUS.FAILED || uploadError ? (
          <>
            <Heading size="h3">
              <Translation>{t => t("form.form-failed")}</Translation>
            </Heading>
            <Flex mt={[4]}>{children}</Flex>
          </>
        ) : null}
      </Box>
    </Flex>
  )
}
